import { Button } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import type {
  FilterConditionDTO,
  OffsetPageQueryDTO,
} from "@/shared/contracts/base";
import {
  findCondition,
  removeConditions,
  upsertCondition,
} from "@/shared/contracts/query-helpers";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";

export function FormSubmissionsFilter() {
  const nav = useNavigate({ from: "/app/forms/$id/submissions" });
  const search = useSearch({
    from: "/app/forms/$id/submissions",
  }) as OffsetPageQueryDTO;
  const filters = (search.filters as FilterConditionDTO[] | undefined) ?? [];

  const statusFilter = findCondition(filters, "status");
  const statusValue = (statusFilter?.value as string) || "all";

  const hasFilter = statusValue !== "all";

  return (
    <div className="mb-4 flex flex-col gap-2 px-2">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-1 flex-wrap items-center gap-2">
          <SimpleSelect
            value={statusValue}
            onValueChange={(val) => {
              let nextFilters: FilterConditionDTO[] | undefined = filters;
              if (val === "all") {
                nextFilters = removeConditions(filters, "status");
              } else {
                nextFilters = upsertCondition(filters, {
                  field: "status",
                  op: "eq",
                  value: val,
                });
              }
              nav({
                search: {
                  ...search,
                  offset: 0,
                  filters: nextFilters?.length ? nextFilters : undefined,
                },
              });
            }}
            placeholder="ສະຖານະການສົ່ງ"
            className="h-8 w-full sm:w-48"
            options={[
              { value: "all", label: "ທຸກສະຖານະ" },
              { value: "draft", label: "ຮ່າງ" },
              { value: "submitted", label: "ສົ່ງແລ້ວ" },
              { value: "in_review", label: "ກຳລັງກວດ" },
              { value: "approved", label: "ອະນຸມັດ" },
              { value: "rejected", label: "ປະຕິເສດ" },
              { value: "cancelled", label: "ຍົກເລີກ" },
            ]}
          />
        </div>
        {hasFilter && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() =>
              nav({
                search: {
                  ...search,
                  offset: 0,
                  filters: undefined,
                },
              })
            }
            className="max-sm:w-full"
          >
            <XIcon className="h-4 w-4" /> ລ້າງ
          </Button>
        )}
      </div>
    </div>
  );
}
